import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';

@Component({
    selector: 'investment-knowledge',
    templateUrl: './investment-knowledge.component.html',
    styleUrls: ['./investment-knowledge.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class EaSubscriptionInvestmentKnowledgeComponent implements OnInit {
  options: FormControlOption[] = [
    {
      value: 'knowMonetaryProduct',
      label: 'Fonds monétaires, Livrets, Fonds Euro',
      suffix: { title: 'A' },
    },
    {
      value: 'knowBond',
      label: 'Obligations',
      suffix: { title: 'C' },
    },
    {
      value: 'knowStock',
      label: 'Actions sur le marché boursier',
      suffix: { title: 'B' },
    },
    {
      value: 'knowScpi',
      label: 'SCPI',
      suffix: { title: 'D' },
    },
    {
      value: 'knowPrivateEquity',
      label: 'Capital investissement',
      suffix: { title: 'E' },
    },
    {
      value: 'knowLifeInsurance',
      label: 'Assurance Vie / PER',
      suffix: { title: 'F' },
    },
    {
      value: 'knowDerivativeProducts',
      label:
        'Produits financiers complexes, Instruments financiers dérivés, ETF, Produits structurés',
      suffix: { title: 'G' },
    },
  ];

  constructor() {}

  ngOnInit() {}
}
